export enum OAuthProviderName {
    VK = 'vk',
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    APPLE = 'apple',
}

export const OAuthProviders: OAuthProviderName[] = [
    OAuthProviderName.VK,
    OAuthProviderName.FACEBOOK,
    OAuthProviderName.GOOGLE,
    OAuthProviderName.APPLE,
];
